var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningCircle = function SvgWarningCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.667 10a8.333 8.333 0 1 0 16.667 0 8.333 8.333 0 0 0-16.667 0Zm15 0a6.667 6.667 0 1 1-13.333 0 6.667 6.667 0 0 1 13.333 0Zm-7.5-4.167a.833.833 0 1 1 1.667 0V10a.833.833 0 1 1-1.667 0V5.833ZM10 12.5a.833.833 0 1 0 0 1.667.833.833 0 0 0 0-1.667Z"
  })));
};
export default SvgWarningCircle;